/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkFlowNotifications {
    getFixupPrototypeFunction() { return WorkFlowNotifications.fixupPrototype; }

    static newInstance(model: Partial<WorkFlowNotifications>): WorkFlowNotifications {
        let obj = Object.assign(new WorkFlowNotifications(), model);
        WorkFlowNotifications.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkFlowNotifications>): WorkFlowNotifications {
        if (!model) return null;
        return WorkFlowNotifications.newInstance(<WorkFlowNotifications> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkFlowNotifications) {
        if (!obj) return;

        models.WorkFlowNotifications.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkFlowNotifications): boolean {
        Object.setPrototypeOf(obj, WorkFlowNotifications.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Type of the notifications.
     */
    notification_type: models.WorkFlowNotificationsType;

    /**
     * Value for the notifications.
     */
    values: Array<string>;

}
